import React from 'react';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import styles from './index.module.scss';

/**
 * 旧画布和工作流统一展示只读提示，文案沿用 Smartcat 已有资源。
 */
export default function ReadonlyNotice() {
  const languageStore = useLanguageStore((state) => state.languageStore);
  return (
    <div className={styles.notice}>
      <IconFont name="eyeFill" fontSize={20} />
      <span>{languageStore.smartcatTranslationText((value) => value.roboneo_web_sharing_room_tips)}</span>
    </div>
  );
}
